import React from "react"
import ExperienceInputWork from "./experience-input-work"
import ExperienceInputEducation from "./experience-input-education"
import ExperienceInputVolunteer from "./experience-input-volunteer"
import ExperienceInputLife from "./experience-input-life"
import ExperienceInputAward from "./experience-input-award"
import ExperienceInputLeadership from "./experience-input-leadership"
import ExperienceInputCertificate from "./experience-input-certificate"
import ExperienceInputCoursework from "./experience-input-coursework"

const ExperienceInput = ({ type }) => {
  switch (type) {
    case "work":
      return <ExperienceInputWork type={type} />
    case "education":
      return <ExperienceInputEducation type={type} />
    case "volunteer":
      return <ExperienceInputVolunteer type={type} />
    case "life":
      return <ExperienceInputLife type={type} />
    case "leadership":
      return <ExperienceInputLeadership type={type} />
    case "award":
      return <ExperienceInputAward type={type} />
    case "certificate":
      return <ExperienceInputCertificate type={type} />
    case "coursework":
      return <ExperienceInputCoursework type={type} />
    default:
      return null
  }
}

export default ExperienceInput
